define('views/poll',['require','views/base/view','jquery','text!templates/poll.ejs'],function(require) {
    'use strict';

    var View = require('views/base/view'),
        $ = require('jquery'),
        template = require('text!templates/poll.ejs');

    var PollView = View.extend({
        autoRender: true,
        className: 'poll hidden',
        region: 'poll',
        template: template,
        listen: {
            'change:visible model': 'changeVisible'
        },
        events: {
            'click .close': 'close'
        },
        changeVisible: function() {
            if (this.model.get('visible')) {
                this.$el.removeClass('hidden');
            } else {
                this.$el.addClass('hidden');
            }

            $(window).trigger('resize');
        },
        close: function() {
            this.model.set('visible', false);
        }
    });

    return PollView;
});

